import { render, staticRenderFns } from "./QuotaManage.vue?vue&type=template&id=a1ade404&scoped=true&"
import script from "./QuotaManage.vue?vue&type=script&lang=js&"
export * from "./QuotaManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ade404",
  null
  
)

export default component.exports